"use strict";

/**
 * @function index returns the first index of the array where the key of the element equals the value
 * @param {array} arr array of objects 
 * @param {string} key the key of each object that will be compared
 * @param {any} value the value being looked for
 * @param {number} from the starting search index
 **/
const index = (arr, key, value, from = 0) => {
  if (arr == null || arr.length === 0) {
    return -1;
  }

  const len = arr.length;

  for (let n = from; n < len; n++) {
    if (arr[n] && arr[n][key] == value) {
      /*eslint-disable-line*/
      return n;
    }
  }

  return -1;
};
/**
 * @function find returns the first element of the array where the key of the element equals the value
 * @param {array} arr array of objects 
 * @param {string} key the key of each object that will be compared
 * @param {any} value the value being looked for
 * @param {number} from the starting search index
 **/


const find = (arr, key, value, from = 0) => {
  const idx = index(arr, key, value, from);
  return idx < 0 ? null : arr[idx];
};
/**
 * @function replace returns the first index of the array where the key of the element equals the value after replacing it with elem
 * @param {array} arr array of objects 
 * @param {string} key the key of each object that will be compared
 * @param {any} value the value being looked for and replaced
 * @param {any} elem the value that will replace the value
 * @param {number} from the starting search index
 **/


const replace = (arr, key, value, elem, from = 0) => {
  const idx = index(arr, key, value, from);

  if (idx >= 0) {
    arr[idx] = elem;
  }

  return idx;
};
/**
 * @function remove returns the first index of the array where the key of the element equals the value after removing it
 * @param {array} arr array of objects 
 * @param {string} key the key of each object that will be compared
 * @param {any} value the value being looked for and removed
 * @param {number} from the starting search index
 **/


const remove = (arr, key, value, from = 0) => {
  const idx = index(arr, key, value, from);

  if (idx >= 0) {
    arr.splice(idx, 1);
  }

  return idx;
};
/**
 * @function removeAll returns an array of all instances where the value was found after removing them from the original array
 * @param {array} arr array of objects 
 * @param {string} key the key of each object that will be compared
 * @param {any} value the value being looked for and removed
 * @param {number} from the starting search index
 **/


const removeAll = (arr, key, value, from = 0) => {
  if (arr == null || arr.length === 0) {
    return -1; // NOTE: THIS LOOKS WRONG
  }

  if (typeof from !== 'number' || from < 0) {
    from = 0;
  }

  const rtn = [];

  for (let n = arr.length - 1; n >= from; n--) {
    if (arr[n] && arr[n][key] == value) {
      /*eslint-disable-line*/
      rtn.push(arr[n]);
      arr.splice(n, 1);
    }
  }

  return rtn;
};
/**
 * @function findRemove returns the first instance where the value was found after removing them from the original array
 * @param {array} arr array of objects 
 * @param {string} key the key of each object that will be compared
 * @param {any} value the value being looked for and removed
 * @param {number} from the starting search index
 **/


const findRemove = (arr, key, value, from = 0) => {
  let rtn = null;
  const idx = index(arr, key, value, from);

  if (idx >= 0) {
    rtn = arr[idx];
    arr.splice(idx, 1);
  }

  return rtn;
};
/**
 * @function diff an object with added removed and same between the 2 arrays
 * @param {array} sArr if in sArr, but not in nArr will be in removed
 * @param {array} nArr if in nArr, but not in sArr, will be in added
 **/


const diff = (sArr, nArr) => {
  const added = [];
  const removed = [];
  const same = [];
  const visited = {};
  sArr = sArr || [];
  nArr = nArr || [];

  if (sArr === nArr) {
    return {
      added,
      removed,
      same: [].concat(sArr)
    };
  }

  sArr.forEach(i => {
    const idx = nArr.indexOf(i);

    if (idx < 0) {
      removed.push(i);
    } else {
      same.push(i);
      visited[idx] = true;
    }
  }); // Check for new ones

  nArr.forEach((i, nIdx) => {
    if (!visited[nIdx]) {
      added.push(i);
    }
  });
  return {
    added,
    removed,
    same
  };
};

const diffByKey = (sArr, dArr, key = 'id') => {
  const kf = typeof key === 'function' ? key : i => i[key];

  const idReducer = (acc, cv) => {
    const k = kf(cv);
    acc[k] = cv;
    return acc;
  };

  const rtn = {
    added: [],
    removed: []
  };
  const oObj = sArr.reduce(idReducer, {});
  const nObj = dArr.reduce(idReducer, {});
  sArr.forEach(p => {
    if (nObj[kf(p)] == null) {
      rtn.removed.push(p);
    }
  });
  dArr.forEach(p => {
    if (oObj[kf(p)] == null) {
      rtn.added.push(p);
    }
  });
  return rtn;
};

exports.index = index;
exports.find = find;
exports.replace = replace;
exports.remove = remove;
exports.removeAll = removeAll;
exports.findRemove = findRemove;
exports.diff = diff;
exports.diffByKey = diffByKey;